import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UpdatePassword } from '../../redux/doctorSlice';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { KeyRound, Info } from 'lucide-react';
import ModalShell, { ModalFooter } from '../common/ModalShell';

// RESET SOMEBODY ELSE'S PASSWORD — the key icon on the Doctors and Patients
// lists. A RESET NEVER PUTS A PASSWORD IN A MAIL OR ON A SCREEN (owner,
// 2 Oct 2026): nobody types a new password here any more. The server
// (PUT /patients/resetpassword/:id) makes the current one stop working and
// sends the person a message telling them to set a new one with Forgot
// password; this modal only asks "are you sure?" and says what happened.
function PasswordUpdateModal({ isOpen, onClose, userId }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.doctor);
    const [busy, setBusy] = useState(false);
    const language = localStorage.getItem('i18nextLng');
    const working = loading || busy;

    const handleReset = async () => {
        setBusy(true);
        try {
            const res = await dispatch(UpdatePassword({ docId: userId, body: {} })).unwrap();
            toast.success(res?.data?.noticeDelivered === false
                ? t('passwordReset.done_not_sent')
                : t('passwordReset.done_sent'));
            onClose();
        } catch (err) {
            const msg = err?.error?.response?.data?.message;
            const text = typeof msg === 'string' ? msg : (language === 'fr' ? msg?.fr : msg?.en);
            toast.warn(text || t('passwordReset.error'));
        } finally {
            setBusy(false);
        }
    };

    if (!isOpen) return null;

    return (
        <ModalShell
            title={<span data-testid="password-update-modal-title">{t('passwordReset.confirm_title')}</span>}
            onClose={onClose}
            closeDisabled={working}
            closeLabel={t('passwordReset.cancel')}
            size="md"
            testId="password-update-modal"
            closeTestId="password-update-modal-close-button"
            contentTestId="password-update-modal-content"
            footer={(
                <ModalFooter
                    onCancel={onClose}
                    cancelLabel={t('passwordReset.cancel')}
                    onSubmit={handleReset}
                    submitLabel={working ? t('passwordReset.resetting') : t('passwordReset.confirm')}
                    busy={working}
                    cancelTestId="password-update-cancel-button"
                    submitTestId="password-update-submit-button"
                />
            )}
        >
            <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center shrink-0">
                    <KeyRound className="w-5 h-5" />
                </div>
                <p className="text-sm text-slate-600 leading-relaxed" data-testid="password-update-modal-text">
                    {t('passwordReset.confirm_text')}
                </p>
            </div>
            <div className="mt-4 flex items-start gap-2 rounded-xl bg-slate-50 border border-slate-200 px-3 py-2.5">
                <Info className="w-4 h-4 text-slate-500 mt-0.5 shrink-0" />
                <p className="text-xs text-slate-500">{t('passwordReset.sessions_note')}</p>
            </div>
        </ModalShell>
    );
}

export default PasswordUpdateModal;
